// Shared PAEI / CAPI dimension metadata for DimensionAllocationPanel, used by
// both the job edit and job (read-only) detail pages.
//
// Accent = the validated categorical hue used for the chart bar / slider
// (fixed order, never cycled: blue, orange, aqua, yellow). Color/bg are a
// darker text-safe shade + light tint of the same hue, used for the badge chip.

export const PAEI_DEFAULTS = {
  producer: 0,
  administrator: 0,
  entrepreneur: 0,
  integrator: 0,
};

export const PAEI_DIMENSIONS = [
  {
    key: "producer",
    label: "Producer",
    description: "Delivers results and gets things done.",
    accent: "#2a78d6",
    color: "var(--blue-ink-800)",
    bg: "var(--blue-tint-100)",
  },
  {
    key: "administrator",
    label: "Administrator",
    description: "Implements systems and process discipline.",
    accent: "#eb6834",
    color: "#9a3412",
    bg: "#ffe4d6",
  },
  {
    key: "entrepreneur",
    label: "Entrepreneur",
    description: "Drives innovation and future direction.",
    accent: "#1baf7a",
    color: "var(--emerald-ink-800)",
    bg: "var(--emerald-tint-100)",
  },
  {
    key: "integrator",
    label: "Integrator",
    description: "Builds cohesion and team alignment.",
    accent: "#eda100",
    color: "var(--amber-ink-800)",
    bg: "var(--amber-tint-100)",
  },
];

export const CAPI_DEFAULTS = { authority: 0, power: 0, influence: 0 };

export const CAPI_DIMENSIONS = [
  {
    key: "authority",
    label: "Authority",
    description: "Formal right to make decisions for this job.",
    accent: "#2a78d6",
    color: "var(--blue-ink-800)",
    bg: "var(--blue-tint-100)",
  },
  {
    key: "power",
    label: "Power",
    description: "Ability to control resources or outcomes.",
    accent: "#eb6834",
    color: "#9a3412",
    bg: "#ffe4d6",
  },
  {
    key: "influence",
    label: "Influence",
    description: "Capacity to persuade or affect others' actions.",
    accent: "#1baf7a",
    color: "var(--emerald-ink-800)",
    bg: "var(--emerald-tint-100)",
  },
];
